import React, { useEffect, useState } from "react";
import '../Component/ParentComponent.scss';
import AddAttributePopup from "../Popup/AddAttributePopup";
import FormAttribute from "./FormAttribute";
import { useDispatch } from "react-redux";
import { FaSave } from "react-icons/fa";
import { IoCopySharp } from "react-icons/io5";
import { BsToggle2Off } from "react-icons/bs";
import { BsToggle2On } from "react-icons/bs";
import { RiDeleteBin4Fill } from "react-icons/ri"
import { GoPlus } from "react-icons/go";
import { MdDragIndicator } from "react-icons/md";
import { createElement, deleteComponent, deleteElement, updateComponent, updateComponentStatus, updateElement, updateElementStatus } from "../../../core/actionCreators/lmsActionCreator";
import JsonViewPopup from "../Popup/JsonViewPopup";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";

//Redirect page data is a child element of the element, described by these attribute keys
const REDIRECT_ATTRIBUTE_IDS = {
    "type": 7,
    "str": 8,
    "category": 9
}

const ParentComponent = (props: any) => {
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { data, user, layoutId, componentId, callbackFn, page,
        order, isDragging, isDragOver, onDragStart, onDragOver, onDrop, onDragEnd } = props

    //Reordering is opt in, the component page renders the same card without it
    const isReorderable = !!onDragStart
    //The card only becomes draggable while the grip is held, so the inputs stay editable
    const [dragEnabled, setDragEnabled] = useState(false)

    const dragEndHandler = () => {
        setDragEnabled(false)
        onDragEnd && onDragEnd()
    }

    const [addAttributePopup, setAttributepopup] = useState(false)
    const [attributes, setAttributes] = useState([])
    const [showCopyIcon, setShowCopyIcon] = useState(false)
    const [showAddIcon, setShowAddIcon] = useState(false)
    const [showSaveIcon, setShowSaveIcon] = useState(false)
    const [showActiveInactiveIcon, setShowActiveInactiveIcon] = useState(false)
    const [showDeleteIcon, setShowDeleteIcon] = useState(false)
    const [childAttributes, setChildAttributes] = useState([])
    const [jsonViewPopUp, setJsonViewPopUp] = useState(false)
    const [currentPage, setCurrentPage] = useState("")
    const [status, setStatus] = useState(false)
    const [showRedirectPageData, setShowRedirectPageData] = useState(false)
    const [redirectPageData, setRedirectPageData] = useState({
        "str": "",
        "type": "",
        "category": ""
    })
    //An element without a child element has no redirect data yet, so it is created here
    const [isAddingRedirect, setIsAddingRedirect] = useState(false)
    const [isSavingRedirect, setIsSavingRedirect] = useState(false)
    const [newRedirectPageData, setNewRedirectPageData] = useState({
        "str": "",
        "type": "",
        "category": ""
    })

    const addAttributeHandler = () => {
        setAttributepopup(true)
    }

    //Assigned rather than guarded, so a refetch that returns no attributes clears the
    //ones already on screen instead of leaving them there
    useEffect(() => {
        setAttributes(data?.parent?.attributes || [])
        setChildAttributes(data?.child?.attributes || [])
    }, [data])

    useEffect(() => {
        if (page === "LAYOUT") {
            setCurrentPage("LAYOUT")
            setStatus(data?.parent?.component?.status)
            setShowAddIcon(true)
            setShowSaveIcon(true)
            setShowActiveInactiveIcon(true)
            setShowDeleteIcon(true)
        }
        if (page === "COMPONENT") {
            setCurrentPage("COMPONENT")
            setStatus(data?.parent?.element?.isDeleted)
            setShowAddIcon(true)
            setShowSaveIcon(true)
            setShowActiveInactiveIcon(true)
            setShowDeleteIcon(true)
            //Reset first, the card is reused when the element it shows changes
            setShowRedirectPageData(false)
            setRedirectPageData({ "str": "", "type": "", "category": "" })
            if (data.child) {
                setShowRedirectPageData(true)
                if (data.child.attributes && Array.isArray(data.child.attributes) && data.child.attributes.length > 0) {
                    setRedirectPageData({
                        "str": data.child.attributes.find((d: any) => d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.str)?.attributeValue,
                        "type": data.child.attributes.find((d: any) => d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.type)?.attributeValue,
                        "category": data.child.attributes.find((d: any) => d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.category)?.attributeValue
                    })
                }
            }
        }
    }, [props])

    const removeAttributeHandler = (id: any) => {
        let res = window.confirm("Are you sure want to delete?")
        if (res) {
            const filteredAttributes = attributes.filter((d: any) => d.id !== id)
            setAttributes([...filteredAttributes])
        }
    }

    const updateClickHandler = () => {
        if (currentPage === "LAYOUT") {
            if (data?.parent?.component?.id) {
                const copiedAttributes: any = [...attributes]
                for (let c of copiedAttributes) {
                    if (typeof (c.id) !== 'number') {
                        delete c.id
                    }
                }
                const payload = {
                    "componentId": data.parent.component.id,
                    "attributes": copiedAttributes,
                    "modifiedBy": user.id || -1
                }
                const callback = () => {
                    callbackFn(layoutId)
                }
                dispatch(updateComponent(payload, callback))
            }
            else {
                alert("Something went wrong.")
                return
            }
        }

        if (currentPage === "COMPONENT") {
            if (data?.parent?.element?.id) {
                const copiedAttributes: any = [...attributes]
                for (let c of copiedAttributes) {
                    if (typeof (c.id) !== 'number') {
                        delete c.id
                    }
                }
                const payload = {
                    "childElement": null,
                    "childAttributes": null,
                    "elementId": data.parent.element.id,
                    "attributes": copiedAttributes,
                    "modifiedBy": user.id || -1
                }
                if (data?.child?.element?.id) {
                    if (data.child.attributes && Array.isArray(data.child.attributes) && data.child.attributes.length > 0) {
                        for (let d of data.child.attributes) {
                            if (d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.type) {
                                d.attributeValue = redirectPageData.type
                            }
                            if (d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.str) {
                                d.attributeValue = redirectPageData.str
                            }
                            if (d.attributeKeyId === REDIRECT_ATTRIBUTE_IDS.category) {
                                d.attributeValue = redirectPageData.category
                            }
                        }
                    }
                    payload["childElement"] = data.child.element
                    payload["childAttributes"] = data.child.attributes
                }
                dispatch(updateElement(payload, callbackFn))
            }

            else {
                alert("Something went wrong.")
                return
            }
        }
    }

    //Creates the child element that holds the redirect data, the element itself already exists
    const createRedirectPageDataHandler = () => {
        const element = data?.parent?.element
        if (!element?.id) {
            toast.error("Something went wrong.")
            return
        }
        if (!newRedirectPageData.type.trim() || !newRedirectPageData.str.trim()) {
            toast.error("type and str are required.")
            return
        }

        const payload = {
            "element": {
                "componentId": element.componentId || Number(componentId),
                "parentId": element.id,
                "order": 1,
                "isDeleted": false
            },
            "attributes": [
                { "attributeKeyId": REDIRECT_ATTRIBUTE_IDS.type, "attributeValue": newRedirectPageData.type },
                { "attributeKeyId": REDIRECT_ATTRIBUTE_IDS.str, "attributeValue": newRedirectPageData.str },
                { "attributeKeyId": REDIRECT_ATTRIBUTE_IDS.category, "attributeValue": newRedirectPageData.category }
            ],
            "modifiedBy": user.id || -1
        }

        setIsSavingRedirect(true)
        dispatch(createElement(payload, (r: any) => {
            setIsSavingRedirect(false)
            if (r) {
                toast.error(r?.statusDescription || "Could not add the redirect page data.")
                return
            }
            toast.success("Redirect page data added.")
            setIsAddingRedirect(false)
            setNewRedirectPageData({ "str": "", "type": "", "category": "" })
            callbackFn && callbackFn()
        }))
    }

    const updateStatusClickHandler = (parentAttribute: any) => {
        if (currentPage === "LAYOUT") {
            const payload = {
                "componentId": parentAttribute.component.id,
                "status": !parentAttribute.component.status,
                "modifiedBy": user.id || -1
            }
            const callback = () => {
                callbackFn(layoutId)
            }
            dispatch(updateComponentStatus(payload, callback))
        }
        if (currentPage === "COMPONENT") {
            const payload = {
                "elementId": parentAttribute.element.id,
                "status": !parentAttribute.element.isDeleted,
                "modifiedBy": user.id || -1
            }
            dispatch(updateElementStatus(payload, callbackFn))
        }
    }

    const deleteClickHandler = (parentAttribute: any) => {
        let res = window.confirm("Are you sure want to delete?")
        if (!res) {
            return
        }

        if (currentPage === "LAYOUT") {
            const callback = () => {
                callbackFn(layoutId)
            }
            dispatch(deleteComponent(`${parentAttribute?.component?.id}?modifiedBy=${user.id || -1}`, callback))
        }

        if (currentPage === "COMPONENT") {
            dispatch(deleteElement(`${parentAttribute?.element?.id}?modifiedBy=${user.id || -1}`, callbackFn))
        }
    }

    const componentClickHandler = (componentName: number, componentId: number) => {
        let path = `/layout/${layoutId}/${componentName}/${componentId}`
        navigate(path)
    }

    //On the layout page `status` is the component status, on the component page it is
    //element.isDeleted, so active means the opposite there
    const isActive = currentPage === "COMPONENT" ? !status : status

    //The name is shown exactly as the API sends it, layout code suffix included
    const displayName = () => data?.parent?.component?.componentName || ""

    //Only elements can redirect, and only when they do not already carry the data
    const canAddRedirectPageData = currentPage === "COMPONENT" && !data?.child

    //Elements have no name of their own, so the most descriptive attribute is used
    const isElement = currentPage === "COMPONENT"
    const element = data?.parent?.element
    const NAME_ATTRIBUTE_KEYS = ["title", "imageTitle", "titleName", "componentLabel"]

    const elementTitle = () => {
        for (let key of NAME_ATTRIBUTE_KEYS) {
            let found: any = attributes.find((a: any) => a.attributeKey === key && a.attributeValue)
            if (found) return found.attributeValue
        }
        return `Element ${element?.order}`
    }

    return (<>
        {jsonViewPopUp && <JsonViewPopup jsonViewPopUp={jsonViewPopUp} setJsonViewPopUp={setJsonViewPopUp} data={data} />}
        {addAttributePopup && <AddAttributePopup
            addAttributePopup={addAttributePopup}
            setAttributepopup={setAttributepopup}
            attributes={attributes}
            setAttributes={setAttributes}
        />}

        <div className={`Component-creation mb-[15px] bg-white m-[15px] rounded-lg shadow-[0_2px_6px_rgba(0,0,0,.06)] ${isDragging ? "is-dragging" : ""} ${isDragOver ? "is-drag-over" : ""}`}
            draggable={dragEnabled}
            onDragStart={onDragStart}
            onDragOver={isReorderable ? onDragOver : undefined}
            onDrop={isReorderable ? onDrop : undefined}
            onDragEnd={isReorderable ? dragEndHandler : undefined}>
            <div className="component-creation-header flex items-center justify-between p-[15px]">
                <div className="flex items-center component-title">
                    {isReorderable && <span className="drag-handle flex items-center"
                        title="Drag to reorder"
                        onMouseDown={() => setDragEnabled(true)}
                        onMouseUp={() => setDragEnabled(false)}>
                        <MdDragIndicator />
                    </span>}
                    {isReorderable && <span className="component-order">{order}</span>}
                    {isElement
                        ? <>
                            <span className="component-order" title={`Element ID ${element?.id}`}>{element?.order}</span>
                            <h2 className="element-title" title={`Element ID ${element?.id}`}>{elementTitle()}</h2>
                        </>
                        : <h2 title={data?.parent?.component?.componentName}
                            onClick={() => componentClickHandler(data?.parent?.component?.componentName, data?.parent?.component?.id)}>{displayName()}</h2>}
                    <span className={`component-status ${isActive ? "active" : "inactive"}`}>
                        {isActive ? "Active" : "Inactive"}
                    </span>
                </div>
                <div className="header-right-sec flex items-center">
                    {showCopyIcon && <button className="card-btn ghost rounded">
                        <IoCopySharp /> <span>Copy</span>
                        <span className="btn-tip">Copy this component to another layout</span>
                    </button>}
                    {showAddIcon && <button onClick={addAttributeHandler} className="card-btn ghost rounded">
                        <GoPlus /> <span>Add&nbsp;Attribute</span>
                        <span className="btn-tip">Add a new attribute field to this component</span>
                    </button>}
                    {showActiveInactiveIcon && <button onClick={() => updateStatusClickHandler(data?.parent)}
                        className="card-btn ghost status-btn rounded">
                        {isActive
                            ? <BsToggle2On className="text-green-600" />
                            : <BsToggle2Off className="text-gray-400" />}
                        <span className="btn-tip">{isActive
                            ? "Deactivate - hide this component from the live page"
                            : "Activate - show this component on the live page"}</span>
                    </button>}
                    {showDeleteIcon && <button onClick={() => deleteClickHandler(data?.parent)} className="card-btn danger rounded">
                        <RiDeleteBin4Fill /> <span>Delete</span>
                        <span className="btn-tip">Remove this component from the layout permanently</span>
                    </button>}
                    {showSaveIcon && <button onClick={updateClickHandler} className="card-btn primary rounded">
                        <FaSave /> <span>Save</span>
                        <span className="btn-tip">Save the attribute changes of this component</span>
                    </button>}
                </div>
            </div>


            <div className="flex flex-wrap">
                {attributes.length > 0 ?
                    attributes.map((d: any, index: number) =>
                        //Keyed by attribute, an index key made React reuse the wrong input
                        //when an attribute in the middle of the list was removed
                        <FormAttribute key={d.id ?? index}
                            removeAttributeHandler={removeAttributeHandler}
                            attributes={attributes}
                            setAttributes={setAttributes}
                            attribute={d} />
                    )
                    : !showRedirectPageData ?
                        <p className="no-attributes px-[15px] pb-[15px]">No attributes yet. Use Add Attribute to create one.</p>
                        : null}

                {/* The element has no child element yet, so the data has to be created */}
                {canAddRedirectPageData && <div className="redirect-page-data w-full mx-[15px] mb-[15px]">
                    <div className="flex items-center justify-between">
                        <h5 className="redirect-title mb-0">Redirect Page Data</h5>
                        {!isAddingRedirect &&
                            <button onClick={() => setIsAddingRedirect(true)} className="card-btn ghost rounded">
                                <GoPlus /> <span>Add&nbsp;Redirect&nbsp;Page&nbsp;Data</span>
                            </button>}
                    </div>

                    {!isAddingRedirect
                        ? <p className="no-attributes">Not set. Add it to send this element to another page.</p>
                        : <>
                            <div className="flex flex-wrap">
                                <div className="form-field">
                                    <label>str</label>
                                    <input type="text" placeholder="e.g. 116122400"
                                        onChange={(e) => setNewRedirectPageData({ ...newRedirectPageData, str: e.target.value })}
                                        value={newRedirectPageData.str} />
                                </div>
                                <div className="form-field">
                                    <label>type</label>
                                    <input type="text" placeholder="e.g. Category"
                                        onChange={(e) => setNewRedirectPageData({ ...newRedirectPageData, type: e.target.value })}
                                        value={newRedirectPageData.type} />
                                </div>
                                <div className="form-field">
                                    <label>category</label>
                                    <input type="text" placeholder="e.g. 116122400"
                                        onChange={(e) => setNewRedirectPageData({ ...newRedirectPageData, category: e.target.value })}
                                        value={newRedirectPageData.category} />
                                </div>
                            </div>
                            <div className="redirect-actions flex items-center">
                                <button onClick={createRedirectPageDataHandler} disabled={isSavingRedirect} className="card-btn primary rounded">
                                    <FaSave /> <span>{isSavingRedirect ? "Saving..." : "Save"}</span>
                                </button>
                                <button onClick={() => setIsAddingRedirect(false)} disabled={isSavingRedirect} className="card-btn ghost rounded">
                                    <span>Cancel</span>
                                </button>
                            </div>
                        </>}
                </div>}

                {showRedirectPageData && <div className="redirect-page-data w-full mx-[15px] mb-[15px]">
                    <h5 className="redirect-title">Redirect Page Data</h5>
                    <div className="flex flex-wrap">
                        <div className="form-field">
                            <label>str</label>
                            <input type="text"
                                onChange={(e) => setRedirectPageData({ ...redirectPageData, str: e.target.value })}
                                value={redirectPageData.str} />
                        </div>
                        <div className="form-field">
                            <label>type</label>
                            <input type="text"
                                onChange={(e) => setRedirectPageData({ ...redirectPageData, type: e.target.value })}
                                value={redirectPageData.type} />
                        </div>
                        <div className="form-field">
                            <label>category</label>
                            <input type="text"
                                onChange={(e) => setRedirectPageData({ ...redirectPageData, category: e.target.value })}
                                value={redirectPageData.category} />
                        </div>
                    </div>
                </div>}
            </div>

            {/* {attributes.length > 0 ? <>
                {attributes.map((d: any) =>
                    <FormAttribute
                        removeAttributeHandler={removeAttributeHandler}
                        attributes={attributes}
                        setAttributes={setAttributes}
                        attribute={d} />
                )}
            </> : null} */}

        </div>
    </>)
}

export default ParentComponent